module.exports = __webpack_public_path__ + "static/media/logo.72a2e980.png";